import { render, staticRenderFns } from "./RegisterForm2Business.vue?vue&type=template&id=3eeec2da&scoped=true&"
import script from "./RegisterForm2Business.vue?vue&type=script&lang=js&"
export * from "./RegisterForm2Business.vue?vue&type=script&lang=js&"
import style0 from "./RegisterForm2Business.vue?vue&type=style&index=0&id=3eeec2da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eeec2da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eeec2da')) {
      api.createRecord('3eeec2da', component.options)
    } else {
      api.reload('3eeec2da', component.options)
    }
    module.hot.accept("./RegisterForm2Business.vue?vue&type=template&id=3eeec2da&scoped=true&", function () {
      api.rerender('3eeec2da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/RegisterForm2Business.vue"
export default component.exports